var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "firmware-develop-details" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "header-left" }, [
        _c("div", { staticClass: "top" }, [
          _c("span", { staticClass: "back", on: { click: _vm.goBack } }, [
            _c("i", {
              staticClass: "iconfont icon-fanhui",
              staticStyle: { "font-size": "24px" },
            }),
          ]),
          _c("span", { staticClass: "title" }, [_vm._v("固件详情")]),
        ]),
      ]),
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form-wrap",
              attrs: { "label-position": "left", "label-width": "140px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c("el-form-item", { attrs: { label: "固件名称" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.rowsData.name))]),
                      ]),
                      _c("el-form-item", { attrs: { label: "固件Key" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.rowsData.id))]),
                      ]),
                      _c("el-form-item", { attrs: { label: "固件类型" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.rowsData.componentTypeName)),
                        ]),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "固件升级超时时间" } },
                        [_c("span", [_vm._v(_vm._s(_vm.rowsData.timeoutTime))])]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c("el-form-item", { attrs: { label: "升级通道号" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.rowsData.upgradeChannelNumber)),
                        ]),
                      ]),
                      _c("el-form-item", { attrs: { label: "自定义编号" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.rowsData.customNumber))]),
                      ]),
                      _c("el-form-item", { attrs: { label: "更新时间" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.rowsData.updateTime))]),
                      ]),
                      _c("el-form-item", { attrs: { label: "备注说明" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.rowsData.description))]),
                      ]),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 4 } }, [
                    _c(
                      "div",
                      { staticClass: "btn", on: { click: _vm.editFirmware } },
                      [_vm._v("编辑固件")]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      [
        _c("div", { staticClass: "title" }, [_vm._v("固件版本管理")]),
        _c(
          "el-form",
          { ref: "form", staticClass: "search-form", attrs: { inline: true } },
          [
            _c(
              "el-col",
              { attrs: { span: 24 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "固件版本" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入固件版本", clearable: "" },
                      model: {
                        value: _vm.formSearch.version,
                        callback: function ($$v) {
                          _vm.$set(_vm.formSearch, "version", $$v)
                        },
                        expression: "formSearch.version",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "上架状态" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.formSearch.isListed,
                          callback: function ($$v) {
                            _vm.$set(_vm.formSearch, "isListed", $$v)
                          },
                          expression: "formSearch.isListed",
                        },
                      },
                      _vm._l(_vm.statusOptions, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "14" },
                    on: {
                      click: function ($event) {
                        return _vm.queryVersionList()
                      },
                    },
                  },
                  [_vm._v("查询")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "add-version-btn",
                    attrs: { type: "primary", size: "14" },
                    on: { click: _vm.creatVersion },
                  },
                  [_vm._v("新建固件版本")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              "header-cell-style": { background: "#F5F6F7" },
              size: "medium",
            },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "version", label: "固件版本" },
            }),
            _c("el-table-column", {
              attrs: { prop: "fileName", label: "固件包" },
            }),
            _c("el-table-column", {
              attrs: { prop: "criticalVersionFlag", label: "关键版本" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(scope.row.criticalVersionFlag ? "是" : "否")
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "isListed", label: "上架状态" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(scope.row.isListed ? "已上架" : "未上架")
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "sign", label: "校验值(MD5）" },
            }),
            _c("el-table-column", {
              attrs: { prop: "size", label: "文件大小" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(scope.row.size / 1024 / 1024) + "M"),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "description", label: "版本说明" },
            }),
            _c("el-table-column", {
              attrs: { prop: "updateTime", label: "更新时间" },
            }),
            _c("el-table-column", {
              attrs: { fixed: "right", label: "操作", width: "260" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "text",
                            disabled: _vm.rolesCode === "SALE",
                            size: "operate",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleDownload(scope.row)
                            },
                          },
                        },
                        [_vm._v("下载")]
                      ),
                      !scope.row.isListed
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "text",
                                disabled: _vm.rolesCode === "SALE",
                                size: "operate",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleEdit(scope.row)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          )
                        : _vm._e(),
                      !scope.row.isListed
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "text",
                                disabled: _vm.rolesCode === "SALE",
                                size: "operate",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleLaunch(scope.row)
                                },
                              },
                            },
                            [_vm._v("固件上架")]
                          )
                        : _vm._e(),
                      !scope.row.isListed
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "text",
                                disabled: _vm.rolesCode === "SALE",
                                size: "operate",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDetele(scope.row)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e(),
                      scope.row.isListed
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "text",
                                disabled: _vm.rolesCode === "SALE",
                                size: "operate",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDown(scope.row)
                                },
                              },
                            },
                            [_vm._v("停用下架")]
                          )
                        : _vm._e(),
                      scope.row.isListed
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "text",
                                disabled: _vm.rolesCode === "SALE",
                                size: "operate",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleModifyLaunch(scope.row)
                                },
                              },
                            },
                            [_vm._v("修改上架范围")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c("el-pagination", {
          attrs: {
            "current-page": _vm.currentPage,
            "page-sizes": [10, 20, 30, 40],
            "page-size": _vm.pageSize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.total,
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.handleCurrentChange,
          },
        }),
        _c("editFirmware", {
          ref: "editFirmware",
          attrs: {
            "rows-data": _vm.rowsData,
            "query-component-info": _vm.queryComponentInfo,
          },
        }),
        _c("addOrEditFirmwareVersion", {
          ref: "addOrEditFirmwareVersion",
          attrs: {
            "add-or-edit-type": _vm.addOrEditType,
            "query-version-list": _vm.queryVersionList,
            "page-type": "firmwareDetails",
            "rows-data": _vm.rowsData,
            "rows-inline": _vm.rowsInline,
          },
        }),
        _c("launchOrModify", {
          ref: "launchOrModify",
          attrs: {
            "launch-rows-data": _vm.launchRowsData,
            "query-version-list": _vm.queryVersionList,
            "launch-or-modify-type": _vm.launchOrModifyType,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }